import React, { useState } from 'react'
import FingersBattleComponent from '../Components/FingerBattle'
import UserContext from '../UserContext';

export const gameStatuses = {
  START: "START",
  ENDED: "ENDED",
  PLAYING: "PLAYING"
}
export default function FingersBattle() {
  const { mode } = React.useContext(
    UserContext
  );

  const [gameStatuse, setgameStatuse] = useState(gameStatuses.START)
  const handlegameStatus = (status) => {
    setgameStatuse(status)
  }
  // setting the theme
  const [dark, setDark] = React.useState(false);
  React.useEffect(() => {
    let darkmode = localStorage.getItem("darkmode")
      ? JSON.parse(localStorage.getItem("darkmode"))
      : false;
    setDark(darkmode);
  }, [mode]);

  return (
    <>
      {/* <h4 className="ml-40 mt-4 text-md">Fingers Battle</h4> */}
      <div className={"md:w-9/12 lg:w-9/12 w-11/12 h-full px-4 py-3 mt-2 mx-auto relative " + (dark ? " divbg-in-darkmode " : " bg-gray-100 ")}>
        <FingersBattleComponent dark={dark} handlegameStatus={handlegameStatus} gameStatus={gameStatuse} />
      </div>
    </>
  )
}
